<template>
    <div class="common-layout">
      <el-container style="min-height: 100vh">
        <el-header style="padding: 0">
          <el-affix :offset="0">
            <HeaderModule />
          </el-affix>
        </el-header>
        <el-main style="padding: 0; margin-top: -60px; background-color: rgba(245, 247, 250, 0.5)">
          <div class="theme">
            <el-text tag="b" class="theme-text theme-title">更新日志</el-text><br/>
            <el-text tag="b" class="theme-text theme-body">明日复明日，明日何其多。 ——钱福</el-text>
          </div>
        </el-main>
        <el-footer>
          <FooterModule />
        </el-footer>
      </el-container>
    </div>
    <BackTop />
    <BackGround style="position: absolute; z-index: -1;" />
  </template>
    
  <script>
  export default {
    components: {},
    setup() {
      
      return {

      };
    },
  };
  </script>
    
<style scoped>
  .theme {
    height: 50vh;
    width: 100%;
    background-image: url("../../assets/img/29dcc02e833def4808ddaded64b4e40.jpg"); /* 确保路径正确 */
    background-size: cover; /* 图片将尽可能大地覆盖整个容器，可能会被裁剪 */  
    background-position: center; /* 图片居中显示 */  
    background-repeat: no-repeat; /* 不重复 */  
    display: flex; /* 启用Flexbox布局 */
    justify-content: center; /* 水平居中 */  
    align-items: center; /* 垂直居中 */  
    flex-direction: column; /* 如果需要子元素垂直排列（在这个例子中不是必需的，但可以用于其他布局）*/  
  }
  .theme h1 {  
    margin: 0; /* 可能需要移除默认的margin来确保更精确的居中 */  
  }
  @font-face {
    font-family: "MyCustomFont";
    src: url("../../assets/font/luzhongmocaishou.ttf") format("opentype");
  }
  .theme-text{
    font-family: "MyCustomFont", sans-serif;
    color: #FFFFFF;
    letter-spacing: 4px;
  }
  .theme-title{
    font-size: 40px;
  }
  .theme-body{
    font-size: 20px;
  }
  </style>